var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 5c0-1.7 1.3-3 3-3h2c1.7 0 3 1.3 3 3v13H6V5zm2 0c0-.6.4-1 1-1h2c.6 0 1 .4 1 1v1H8V5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h2V6H2zM18 6h-2v12h2c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1z"
  })));
};
export default SvgBriefcase;